export const cols_1= [

    {
        title:"货号",
        key:'orderId',                   
        align:"center",                   
        width:'10vw',                   
    },
    {
        title:"批次",
        key:'batch',
        align:"center",    
    },

    {
        title:"计划件数",
        key:'orderNum',
        align:"center",        
    } ,    
    {
        title:"销量",
        key:'quantity',
        align:"center",        
    }, 
    {
        title:"销售额",
        key:'money',
        align:"center",        
    }, 
    {
        title:"大仓库存",
        key:'warehouseQty',
        align:"center",        
    }
  ]

  export const cols_2= [
    {
        title:"货号",
        key:'goodsNo',                   
        align:"center",                    
    },
    {
        title:"图片",
        key:'pic',            
        slot:'img',
        align:"center"           
    },
    {
        title:"颜色",
        key:'color',
        align:"center"     
    },
     {
        title:"批次",
        key:'batch',
        align:"center"           
    },               
   {
        title:"下单量",
        key:'orderNum',
        align:"center"      
    },                 
    {
        title:"入库量",
        key:'comeNum',
        align:"center"      
    }          
   
      

  ]